
// Global Variables
const desktop = window.matchMedia("(min-width: 1281px)");
const tablet = window.matchMedia("(max-width: 991px)");
const mobile = window.matchMedia("(max-width: 590px)");
const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

module.exports = { desktop, tablet, mobile, scrollElement }
